import React, { useEffect, useRef } from "react"
import { geoAlbersUsa, geoPath } from "d3-geo"
import { select } from "d3-selection"
import { scaleLinear } from "d3-scale"
import { extent } from "d3-array"
import * as classes from "./SvgMap.module.scss"
import { OverlayTrigger, Tooltip } from "react-bootstrap"

const SvgMap = ({ onSetState, data, state }) => {
  const svgRef = useRef()

  let projection,
    path,
    colourScale = () => "green"

  useEffect(() => {
    const svg = svgRef.current
    if (svg) {
      select(svg)
        .selectAll("path")
        .on("mouseover", e => select(e.target).raise())
    }
  }, [svgRef.current])

  if (svgRef.current) {
    projection = geoAlbersUsa()
      .translate([
        svgRef.current.clientWidth / 2,
        svgRef.current.clientHeight / 2,
      ])
      .scale([(svgRef.current.clientWidth / 853) * 1000])
    path = geoPath().projection(projection)

    if (data.features) {
      colourScale = scaleLinear()
        .domain(
          extent(data.features.map(d => +d.properties.shops_100k.toFixed(2)))
        )
        .range(["#fde7e5", "#ee7676"])
    }
  }

  return (
    <svg className={classes.Svg} ref={svgRef}>
      {data &&
        data.features &&
        data.features.map(d => (
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 0 }}
            overlay={
              <Tooltip>
                <span className={classes.Tooltip__Title}>
                  {d.properties.STATE_NAME}
                </span>
                <br />
                {d.properties.shops_100k.toFixed(2)} shops per 100,000 people
              </Tooltip>
            }
            key={d.properties.STATE_NAME}
          >
            <path
              className={classes.Path__state}
              d={path(d)}
              fill={
                d.properties.STATE_NAME === state.properties.STATE_NAME
                  ? "#ffbd59"
                  : colourScale(d.properties.shops_100k.toFixed(2))
              }
              onClick={() => {
                console.log(d)
                return onSetState(d)
              }}
            ></path>
          </OverlayTrigger>
        ))}
    </svg>
  )
}

export default SvgMap
